"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiaryEntryCreateForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DiaryCards_1 = require("./DiaryCards");
const DiaryEntryDto_1 = require("./interface/DiaryEntryDto");
const helpers_1 = require("../../helpers");
const defaultDiaryEntry = {
    id: -1,
    typ: DiaryEntryDto_1.DiaryEntryType.ZAVADA,
    datum: new Date(),
    text: '',
    provedl: '',
    poznamka: '',
    email: '',
    telefon: '',
    uzivatel: '',
    opraveno: false
};
const DiaryEntryCreateForm = ({ diaryEntryTypeList, mainCardTitle, dispatchCreate, onCreateSuccess, textSuggestions, submitButtonVersion = "top", defaultValues, fullSize }) => {
    return ((0, jsx_runtime_1.jsx)(helpers_1.FormWithCreate, { initValues: { ...defaultDiaryEntry, ...defaultValues }, dispatchCreate: dispatchCreate, onCreateSuccess: onCreateSuccess, ...(submitButtonVersion === "bottom" ? {
            buttonLabel: "Přidat hlášení",
            bottomButton: true,
            fullWidth: true
        } : {}), children: () => ((0, jsx_runtime_1.jsx)(DiaryCards_1.DiaryCards, { mainCardTitle: mainCardTitle, fullSize: fullSize, mode: helpers_1.FormMode.EDIT, version: helpers_1.FormVersion.CREATE, textSuggestions: textSuggestions, diaryEntryTypeList: diaryEntryTypeList })) }));
};
exports.DiaryEntryCreateForm = DiaryEntryCreateForm;
